import { Component, effect, input, output, signal } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import type { filterEntity } from '../types'

@Component({
  selector: 'dhp-filter-entities-dropdown',
  templateUrl: './filter-entities-dropdown.html',
  imports: [TranslatePipe],
})
export class FilterEntitiesDropdown {
  //region Inputs
  // The items that can be filtered on
  public readonly originalItems = input.required<Set<filterEntity>>()
  //endregion Inputs

  //region Outputs
  // The filter output, which is the set of selected item ids. It is emitted when the selection changes.
  public readonly itemOutput = output<number | null>()
  //endregion Outputs

  //region Properties
  // State of items after filtering with the search term. Initially is empty
  protected readonly items = signal<Set<filterEntity>>(new Set())
  // the if of the selected item. It is used to determine which item is selected and to emit the selected item when it changes.
  protected selectedItemId: number | null = null

  //endregion Properties

  constructor() {
    effect(() => {
      // Clone into a new Set so internal filtering doesn't mutate the input set reference
      this.items.set(new Set(this.originalItems()))
    })
  }

  // Modifies the state of the selected items when an item is selected or deselected.
  onItemSelectedChange(event: Event): void {
    const element = event.target as HTMLSelectElement

    this.selectedItemId = parseInt(element.value)
    this.itemOutput.emit(this.selectedItemId)
  }

  protected readonly HTMLSelectElement = HTMLSelectElement
}
